import { Component } from '@angular/core';

@Component({
  selector: 'oren-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'oren';
}
